"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Banner.css");
var Banner = function (_a) {
    var text = _a.text, linkText = _a.linkText, underlinedLinkText = _a.underlinedLinkText, onClick = _a.onClick;
    return (React.createElement("div", { className: "payments-banner" },
        React.createElement("div", { className: "wrapper" },
            React.createElement("div", { className: "text" }, text),
            linkText && (React.createElement("div", { className: "link" },
                linkText,
                underlinedLinkText && (React.createElement("span", { className: "underline", onClick: function (e) { return (onClick ? onClick(e) : function () { }); } }, underlinedLinkText)))))));
};
exports.default = Banner;
